import type { State } from '../../types';
import type { ContactPersonViewModel } from '@trinnvis/dabih-api-client';
import { sortBy } from 'lodash';

import { toList } from '../toList';

export function contactsNotDeleted(state: State): ContactPersonViewModel[] {
  if (state.organization === undefined) return [];
  return sortBy(
    toList(state.organization.contactsById).filter(function (e) {
      return !e.deleted;
    }),
    (e) => e.firstName.toLowerCase() + ' ' + e.lastName.toLowerCase(),
  );
}
